export default function jigneshApi(fetch, baseUrl) {
  return {
    ask(question) {
      return fetch.post(`${baseUrl}`, {
        question
      });
    }
  };
}
